import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen items-center bg-white pt-20">
      <div className="mx-auto max-w-xl px-5 py-24 text-center">
        <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946]">Checkout canceled</p>
        <h1 className="font-display mt-5 text-4xl font-extrabold tracking-tight text-[#111111]">
          No charge was made.
        </h1>
        <p className="mt-4 text-base leading-relaxed text-neutral-600">
          Your payment was canceled before anything was processed. Whenever
          you're ready, you can pick up right where you left off — or send an
          inquiry and we'll plan it together first.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/services"
            data-testid="payment-cancel-services-link"
            className="inline-flex items-center gap-2 bg-[#111111] px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-[#e63946]"
          >
            Back to services
          </Link>
          <Link
            to="/contact"
            data-testid="payment-cancel-contact-link"
            className="group inline-flex items-center gap-2 border border-neutral-300 px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-[#111111] transition-colors duration-300 hover:border-[#111111]"
          >
            <ArrowLeft className="h-4 w-4" />
            Send an inquiry
          </Link>
        </div>
      </div>
    </div>
  );
}
